<app-spinner-overlay></app-spinner-overlay>
<div class="contenitore">
  <div class="titolo-pagina">
    <app-titolo-subtitolo titolo="Doppia Materialità" subTitolo=""></app-titolo-subtitolo>
  </div>
  <app-lista-tabellare
    #tabella
    [fnCaricamentoDati]="fnCaricamentoDati"
    [colonne]="colonne"
    [maxNrButton]="1"
    [filtri]="filtri"
    (bottoniListaClick)="bottoniListaClick($event)"
  >
    <div btnEnd>
      <button
        mat-flat-button
        class="primary-button"
        color="primary"
        (click)="creaNuovo()"
        *ngIf="this.utenteService.isPermessoAttivo('CREATE_DOPPIA_MATERIALITA')"
      >
        Nuovo
      </button>
    </div>
  </app-lista-tabellare>
</div>
